/**
 * Platzhalter an der Zielposition (SPEC 8.2.4): gestrichelter Rahmen in der
 * Akzentfarbe, exakt in Hoehe der gezogenen Karte. Die umliegenden Karten
 * weichen aus, weil der Platzhalter Platz beansprucht — dafuer braucht es
 * keine Transforms, nur Layout und eine Uebergangszeit von 150 ms.
 */
export function DropIndicator({ height }: { height: number }) {
  return (
    <div
      data-testid="drop-indicator"
      aria-hidden="true"
      className="rounded-[var(--radius)] border-2 border-dashed border-accent bg-accent-soft"
      style={{ height, transition: 'height 150ms ease, opacity 150ms ease' }}
    />
  );
}
